import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import { useTranslation } from 'react-i18next'

import Loader from '../../loader'
import ReviewList from '../../review-list'
import Stars from '../../stars'
import ReviewDialog from '../review'

import { useBookReviews } from '../../../../data/hooks/reviews'
import { useScrollTrigger } from '../../../../data/hooks/interface/scroll-trigger'
import { Book, BookWithRating } from '../../../../data/book/data-types'
import { DialogLevel, useDialog } from '../../dialog/hook'
import { changeRating } from '../../../../data/book/reviews'
import { useAuth } from '../../../../data/hooks/auth'
import { useAuthForms } from '../auth'


type BookReviewsProps = {
  book: Book | BookWithRating
}

const BookReviews: React.FunctionComponent<BookReviewsProps> = ({ book }) => {
    const bookId = book?.id!
    const bookWithRating = book as BookWithRating

    const { setComponent } = useDialog()
    const { token } = useAuth()
    const { showRegisterForm } = useAuthForms()
    
    const { t } = useTranslation("reviews")
    
    const [_, setScrollable] = useScrollTrigger({
        bottomStopCondition: () => reviewsState.final || reviewsState.pending,
        onBottomReached: () => loadReviews(reviewsState?.reviews?.length || 0, 20),
    })

    const [reviewsState, loadReviews] = useBookReviews(bookId)
    const [rating, setRating] = useState(bookWithRating.rating?.user)

    useEffect(() => {
        loadReviews(0, 10)
    }, [bookId])

    return (
        <Container ref={r => setScrollable(r)}>
            {
                bookWithRating && bookWithRating.rating &&
                <MyRating>
                    {t("my_rating")}: <Stars value={rating || 0} onValueChanged={(value) => {
                        setRating(value)

                        if (token?.access) {
                            changeRating(bookId, value, token?.access!)

                            setComponent(
                                <ReviewDialog 
                                    book={{ 
                                        ...book, 
                                        rating: { 
                                            ...(bookWithRating.rating || {}),
                                            user: value,
                                        }
                                    }}
                                />, 
                                undefined, 
                                DialogLevel.Top, 
                                true,
                            )
                        } else {
                            showRegisterForm()
                        }
                    }}/>
                </MyRating>
            }
            <ReviewList focus={'author'} reviews={reviewsState.reviews} emptyState='No reviews for this book yet' final={reviewsState.final} />
            {reviewsState.pending && <Loader />}
        </Container>
    )
}

const Container = styled.div`
  display: grid;
  justify-items: center;
  align-items: center;
`

const MyRating = styled.div`
    display: grid;
    grid-template-columns: auto 1fr;
    grid-gap: 16px;

    justify-items: start;
    align-items: center;

    margin-bottom: 32px;

    height: 40px;
    width: 100%;

    cursor: pointer;
`


export default BookReviews